
import {
  defineComponent,
  onMounted,
  onUnmounted,
  computed,
  watch,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { removeModalBackdrop } from "@/core/helpers/dom";
import { reinitializeComponents } from "@/core/plugins/keenthemes";

export default defineComponent({
  name: "auth-page-layout",
  components: {},
  setup() {
    const store = useStore();
    const route = useRoute();
    const themeMode = computed(() => {
      return store.getters.getThemeMode;
    });

    onMounted(() => {
      nextTick(() => {
        reinitializeComponents();
      });
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    watch(
      () => route.path,
      () => {
        nextTick(() => {
          reinitializeComponents();
        });
        removeModalBackdrop();
      }
    );

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });

    return {
      getIllustrationsPath,
      themeMode,
    };
  },
});
